import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { setSettlement } from 'services/fund/settlement'

export default function useAddSettlement() {
    const navigate = useNavigate()
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: ISetSettlementPayload) => {
            return setSettlement(payload)
        },
        onSuccess: (_, variables) => {
            toast.success('درخواست تسویه و خروج ثبت شد')
            navigate(-1)
        },
        onError: () => {
            toast.error('خطایی رخ داده!')
        },
    })
    return { mutate, isLoading }
}
